export class FlexApiError extends Error {
    constructor(msg: string) {
        super(msg);
        this.name = new.target.prototype.constructor.name;
        Object.setPrototypeOf(this, FlexApiError.prototype);
    }
}

export class GetShiftsError extends FlexApiError {
    constructor(msg: string) {
        super(msg);
        this.name = new.target.prototype.constructor.name;
        Object.setPrototypeOf(this, GetShiftsError.prototype);
    }
}

export class DuplicateShiftBookingError extends FlexApiError {
    constructor(msg: string) {
        super(msg);
        this.name = new.target.prototype.constructor.name;
        Object.setPrototypeOf(this, DuplicateShiftBookingError.prototype);
    }
}
